const mappingFields = [['__consumer_phone__', 'phone1'],
  ['__consumer_name__', 'fullname'],
  ['__consumer_email__', 'email'],
  ['__consumer_firstname__', 'firstname'],
  ['__consumer_lastname__', 'lastname'],
  ['__agent_id__', 'agent_id'],
  ['__agent_name__', 'agent_name'],
  ['__call_center_dba__', 'call_center_dba'],
  ['__consumer_address__', 'address'],
  ['__consumer_city__', 'city'],
  ['__consumer_state__', 'state'],
  ['__consumer_zip__', 'zip']]
const FORM_ELEMENT_COMPUTED_MIXIN = {
  computed: {
    label () {
      var label = this.question.label
      mappingFields.forEach((item) => {
        label = label.replace(new RegExp(item[0], 'g'), this.leadInfo[item[1]] ?? '')
      })
      return label
    }
  }
}

export default FORM_ELEMENT_COMPUTED_MIXIN
